import { grey } from '@mui/material/colors';
import { ComponentThemeType } from './theme.types';

export const tableTheme: ComponentThemeType = {
  MuiTableContainer: {
    styleOverrides: {
      root: {
        borderRadius: '5px',
      },
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: ({ theme: { palette } }) => ({
        background: palette.mode === 'light' ? palette.grey[100] : grey['800'],
        textTransform: 'uppercase',

        '.MuiTableCell-root,.MuiTableSortLabel-root': {
          // color: theme.palette.primary.main,
        },
      }),
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        verticalAlign: 'baseline',
        '& th': {
          border: 'none',
        },
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: ({ theme: { palette } }) => ({
        color: palette.grey[600],
        fontWeight: 700,
      }),
    },
  },
};
